
import React from 'react'
import { FaGraduationCap } from "react-icons/fa6";
import { FaTwitter, FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <section className='bg-[#5146AE] py-[60px] mb-[-20px]'>
        <section className='flex justify-between w-[90%] mx-auto md:flex-col'>
            <div className='w-[30%] md:w-[100%]'>
            <div className='flex my-auto'>
                <span className='bg-[#E57853] w-[30px] h-[30px] flex justify-center items-center rounded-lg'>
                <FaGraduationCap color='white' />
                </span>
                <span className='text-white ml-2 font-medium text-2xl logo'>Quest-Inspire</span>
            </div>
            <p className='text-white my-6'>
            We are your partners in unlocking the doors to your educational success. Start your journey to success with us today and thrive.
            </p>
            <div className='flex'>
                <FaTwitter color="white" className='w-[24px] h-[24px]' />
                <FaFacebookF color="white" className='w-[24px] h-[24px] ml-3' />
                <FaLinkedinIn color="white" className='w-[24px] h-[24px] ml-3' />
                <FaInstagram color="white" className='w-[24px] h-[24px] ml-3' />
            </div>
            </div>
            <div className='md:hidden'>
                <h2 className='font-medium text-base text-white'>Useful Links</h2>
                <ul className='mt-6'>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white ' to="/">Terms & Condition</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/join-us">Become a tutor</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Our Blog</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Contact</Link>
                    </li>
                    <li>
                        <Link className='text-base font-normal text-white' to="/">FAQ</Link>
                    </li>
                </ul>
            </div>
            <div className='md:hidden'>
            <h2 className='font-medium text-base text-white'>Services</h2>
            <ul className='mt-6'>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Application</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Tutoring</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Result Checking</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Study Abroad</Link>
                    </li>
                    <li>
                        <Link className='text-base font-normal text-white' to="/">Exam Registration</Link>
                    </li>
                </ul>
            </div>
            <div className='md:hidden'>
            <h2 className='font-medium text-base text-white'>Information</h2>
            <ul className='mt-6'>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Home</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/about">About Us</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/admissions">Admission</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Our Blog</Link>
                    </li>
                    <li>
                        <Link className='text-base font-normal text-white' to="/">Student Login</Link>
                    </li>
                </ul>
            
            </div>
            <div className='md:hidden'>
            <h2 className='font-medium text-base text-white'>Legal</h2>
            <ul className='mt-6'>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/terms-and-conditions">Privacy Ploicy</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/terms-and-conditions">Terms & Condition</Link>
                    </li>
                    <li>
                        <Link className='text-base font-normal text-white' to="/terms-and-conditions">Refund Policy</Link>
                    </li>
                  
                </ul>
            </div>
            <section className='md:flex gap-4 w-full justify-between hidden mt-10'>
            <div>
                <h2 className='font-medium text-base text-white'>Useful Links</h2>
                <ul className='mt-6'>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white ' to="/terms-and-conditions">Terms & Condition</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/join-us">Become a tutor</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Our Blog</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/contact">Contact</Link>
                    </li>
                    <li>
                        <Link className='text-base font-normal text-white' to="/">FAQ</Link>
                    </li>
                </ul>
            </div>
            <div>
            <h2 className='font-medium text-base text-white'>Services</h2>
            <ul className='mt-6'>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/admissions">Application</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/join-us">Tutoring</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Result Checking</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Study Abroad</Link>
                    </li>
                    <li>
                        <Link className='text-base font-normal text-white' to="/">Exam Registration</Link>
                    </li>
                </ul>
            </div>
            </section>
            <section className='md:flex gap-4 w-full justify-between hidden mt-10'>
            <div>
            <h2 className='font-medium text-base text-white'>Information</h2>
            <ul className='mt-6'>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Home</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/about">About Us</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/admissions">Admission</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/">Our Blog</Link>
                    </li>
                    <li>
                        <Link className='text-base font-normal text-white' to="/">Student Login</Link>
                    </li>
                </ul>
            
            </div>
            <div>
            <h2 className='font-medium text-base text-white'>Legal</h2>
            <ul className='mt-6'>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/terms-and-conditions">Privacy Ploicy</Link>
                    </li>
                    <li className='mb-3'>
                        <Link className='text-base font-normal text-white' to="/terms-and-conditions">Terms & Condition</Link>
                    </li>
                    <li>
                        <Link className='text-base font-normal text-white' to="/terms-and-conditions">Refund Policy</Link>
                    </li>
                  
                </ul>
            </div>
            </section>
        </section>
    </section>
  )
}

export default Footer